import React, {useEffect, useState} from 'react';
import Util from '../Service/util';
import LoginSvg from "../../assets/svg/mentor.svg"
import ProfileImage from './ProfileImage/ProfileImage';

function Mentor() {
  const util = new Util();
  let [ profileData , SetProfileDta] = useState()

  useEffect(()=>{
    SetProfileDta(util.getUserDetails());
  },[])

  return (
    <div className='container text-center text-dark h2 my-2 d-flex flex-column align-items-center'  style={{minHeight:"90vh",
    backgroundImage: `url(${LoginSvg})`,
    backgroundRepeat:'no-repeat',
    fontWeight:"revert-layer",
    textShadow:"3px 3px #C0C0C0",

     }}>
  
      <h1 className='h1'>Mentor Account</h1>

      <div className="p-0 m-0 h5 text-primary d-flex flex-column align-items-center" style={{textDecoration: 'none',  fontWeight:"600",
   textShadow:"0px 0px #C0C0C0"
}}>

        <ProfileImage profileData={profileData}/>
        <div className='d-flex flex-column'>
        <div className="text-start text-center"> &nbsp; {profileData?.name.toUpperCase()} </div>
        <div className="text-start"> &nbsp; {profileData?.email} </div>
        </div>
      </div>
    </div>
  );
}

export default Mentor;

